import { cloneDeep } from 'lodash';
import { useGlobalEditorStore } from './EditorStore.tsx';

// Interface for cache configuration
interface CacheConfig {
  scope?: 'global' | 'local';
  expiryTime?: number;
  strategy?: string;
  tabBehavior?: string;
  clearOnRefresh?: boolean;
}

// Interface for the props parameter of useSuperEditor
export interface UseSuperEditorProps {
  id?: string;
  name?: string;
  cacheConfig?: CacheConfig;
}

// Interface for the template object
export interface Template {
  [key: string]: any;
}

// Interface for the return value of useSuperEditor
export interface UseSuperEditorReturn {
  template: Template | null;
  updateTemplate: (updatedTemplate: Partial<Template>) => void;
  resetTemplate: () => void;
  getTemplate: () => Template | null;
}

export const useSuperEditor = (
  props: UseSuperEditorProps = {}
): UseSuperEditorReturn => {
  const id = props?.id;
  const name = props?.name;
  const cacheConfig = props?.cacheConfig;

  const editorStore = useGlobalEditorStore({
    id,
    name,
    cacheConfig
  });

  const template = editorStore((s) => s.template);
  const setTemplate = editorStore((s) => s.setTemplate);
  const getTemplate = () => {
    return editorStore.getState().template;
  };

  const updateTemplate = (updatedTemplate: Partial<Template>) => {
    const currentTemplate = template ? cloneDeep(template) : {};
    const updatedTemplateData = {
      ...currentTemplate,
      ...updatedTemplate
    };
    setTemplate(updatedTemplateData);
  };

  const resetTemplate = () => {
    setTemplate(null);
  };

  return {
    template,
    updateTemplate,
    resetTemplate,
    getTemplate
  };
};
